'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  display: block;\n  margin: 0px;\n  padding: 0px;\n'], ['\n  width: 100%;\n  display: block;\n  margin: 0px;\n  padding: 0px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: none;\n  opacity: 0;\n  pointer-events: none;\n'], ['\n  display: none;\n  opacity: 0;\n  pointer-events: none;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 0px !important;\n  height: 0px !important;\n  visibility: hidden !important;\n  opacity: 0 !important;\n  pointer-events: none !important;\n  position: fixed !important;\n  top: -100% !important;\n  left: -100% !important;\n  z-index: -10000000;\n  margin: 0px !important;\n  padding: 0px !important;\n  border: none !important;\n  background: none !important;\n'], ['\n  width: 0px !important;\n  height: 0px !important;\n  visibility: hidden !important;\n  opacity: 0 !important;\n  pointer-events: none !important;\n  position: fixed !important;\n  top: -100% !important;\n  left: -100% !important;\n  z-index: -10000000;\n  margin: 0px !important;\n  padding: 0px !important;\n  border: none !important;\n  background: none !important;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Container = _styledComponents2.default.form(_templateObject);

var HiddenInput = _styledComponents2.default.input(_templateObject2);

var Enter = _styledComponents2.default.button(_templateObject3);

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (e) {
      e.preventDefault();

      _this.props.onSubmit(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onSubmit = _props.onSubmit,
          enter = _props.enter,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['onSubmit', 'enter', 'children']);

      return _react2.default.createElement(Container, _extends({
        onSubmit: this.onSubmit,
        autoComplete: 'off'
      }, props), _react2.default.createElement(HiddenInput, {
        autoComplete: 'false'
      }), children, enter && _react2.default.createElement(Enter, {
        type: 'submit'
      }));
    }
  }]);

  return Form;
}(_react.Component);

Form.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node.isRequired,
  enter: _propTypes2.default.bool
};
Form.defaultProps = {
  enter: false
};
exports.default = Form;